/**
 * Canonical timezone defaults (#952).
 *
 * The team operates on US Eastern, so a schedule entered without an explicit
 * timezone means Eastern wall-clock. These live in a neutral module because
 * both the connector-schedule surfaces and the Settings display preference
 * need them, and Settings must not import from components/connectors/.
 *
 * Two constants, not one: they are separate axes that could diverge later.
 */
export const DEFAULT_SCHEDULE_TIMEZONE = 'America/New_York';
export const DEFAULT_DISPLAY_TIMEZONE = 'America/New_York';
